<template>
  <img :src="imageFor" />
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "PreviousImage",
  props: {
    session: {
      type: Object
    }
  },
  computed: {
    imageFor() {
      console.log("get image");
      return sanityImageBuilder
        .image(this.session.previewImage)
        .width(400)
        .url();
    }
  }
};
</script>

<style scoped></style>
